var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg30(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 10.2988V25.4245H10.2738V19.4178L14.2954 25.4245H19.4615L14.1254 17.4886H10.2738V10.2988H6Z",
    fill: "#B7B7B7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4397 4L20.821 18.0786L19.5588 15.6981C19.5588 15.6981 18.7176 14.1727 18.025 13.4814L12.5268 19.8074L9.30566 17.0077L14.8044 10.6811C14.0241 10.0902 12.3965 9.47075 12.3965 9.47075L9.86364 8.55276L23.4397 4Z",
    fill: "#E3007E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg30);
export default __webpack_public_path__ + "static/media/키움증권-30.c6f850cb3193c642b67df9cb943b382b.svg";
export { ForwardRef as ReactComponent };